// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/cardsList/stylesheet/style.scss
 ** module id = 404
 ** module chunks = 1
 **/